export default "__VITE_ASSET__BJY0a4fU__"